import { useTranslation } from 'react-i18next';
const Reviews = ({ data }) => {
    const showNewReviews = true;
    const { t } = useTranslation();
    const { reviews } = t('cabin');

    return showNewReviews ?
        <div className="pb-4">
            <p className='text-jobos-brown fs-45 fw-bold m-0 pb-4' style={{ textAlign: 'center' }}>{reviews}</p>
            <script src="https://static.elfsight.com/platform/platform.js" async></script>
            <div className="elfsight-app-f1199eac-0495-470b-8cbe-31b9a9ae98e9" data-elfsight-app-lazy></div>
        </div>
        :
        <div className="pb-4">
            <div id="caruselReviews" className="carousel slide" data-bs-ride="carousel">
                <div className="row g-0">
                    <div className="col">
                        <div className='d-flex align-items-center justify-content-center h-100'>
                            <button className="border-0 p-0 bg-transparent" type="button" data-bs-target="#caruselReviews" data-bs-slide="prev">
                                <i className="fa-solid fa-chevron-left text-jobos-green fs-45"></i>
                            </button>
                        </div>
                    </div>
                    <div className="col-7">
                        <div className="carousel-inner">
                            {
                                data.map((review, index) => {
                                    return (
                                        <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                                            <div className="reviews-text">
                                                <p className="fs-15 fw-normal lh-30 mb-5">{review.usercomment}</p>
                                            </div>
                                            <div className="fw-normal lh-30">
                                                <p className="fs-18 m-0">{review.username}</p>
                                                <p className="fs-14 m-0">{review.usercountry}</p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="col">
                        <div className='d-flex align-items-center justify-content-center h-100'>
                            <button className="border-0 p-0 bg-transparent" type="button" data-bs-target="#caruselReviews" data-bs-slide="next">
                                <i className="fa-solid fa-chevron-right text-jobos-green fs-45"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

}

export default Reviews